import { memo } from 'react';
import { useTranslate } from '@tolgee/react';
import { isDefaultAdmin, isDefaultAssistant, isDefaultSupperAdmin } from 'views/Assistant/utils';

interface RoleDescriptionProps {
  value?: string;
  source: StoreHomeV2.RoleWithDepartment;
}

const RoleDescriptionComponent = (props: RoleDescriptionProps) => {
  const {
    value,
    source: { name, isDefault },
  } = props;
  const { t } = useTranslate();

  if (value) return <>{value}</>;

  if (isDefaultAssistant(name, isDefault)) {
    return <>{t('role_desc_default_assistant')}</>;
  }

  if (isDefaultAdmin(name, isDefault)) {
    return <>{t('role_desc_default_admin')}</>;
  }

  if (isDefaultSupperAdmin(name, isDefault)) {
    return <>{t('role_desc_default_super_admin')}</>;
  }

  return <>-</>;
};

export const RoleDescription = memo(RoleDescriptionComponent);
